import { Injectable, inject } from "@angular/core";
import { SessionService } from "@kno2/core/session";
import {
    AccountOrganizationCanceledModalComponent,
    AccountOrganizationGracePeriodModalComponent,
    AccountOrganizationReactivationModalComponent
} from "@kno2/features/account/organization";
import { DialogService } from "@kno2/shared/dialog";

@Injectable({
    providedIn: "root"
})
export class OrganizationStatusService {
    private readonly sessionService = inject(SessionService);
    private readonly dialogService = inject(DialogService);

    public async initializeOrganizationStatusWorkflow(): Promise<void> {
        const profile = this.sessionService.profileData();

        if (!profile) {
            return;
        }

        const orgIsCanceled = profile.orgIsCancelled;
        const isAdmin = profile.isAdmin;
        const subscriptionReference = profile.subscriptionReference;

        if (orgIsCanceled && isAdmin && subscriptionReference != null) {
            setTimeout(() => this.openReactivationModal(), 1000);
        } else if (orgIsCanceled && !isAdmin) {
            setTimeout(() => this.openCancelledOrgModal(), 1000);
        } else if (!orgIsCanceled && profile.orgIsInGracePeriod) {
            setTimeout(() => this.openGracePeriodOrgModal(), 1000);
        }
    }

    private async openReactivationModal(): Promise<void> {
        await this.dialogService.open(AccountOrganizationReactivationModalComponent, {
            dialogId: "reactivate-organization-modal",
            headerText: "Organization is currently canceled",
            closeOnEscape: false,
            closable: false
        });
    }

    private async openCancelledOrgModal(): Promise<void> {
        await this.dialogService.open(AccountOrganizationCanceledModalComponent, {
            dialogId: "cancel-organization-modal",
            headerText: "Organization is currently canceled",
            closeOnEscape: false,
            closable: false
        });
    }

    private async openGracePeriodOrgModal(): Promise<void> {
        await this.dialogService.open(AccountOrganizationGracePeriodModalComponent, {
            dialogId: "grace-period-organization-modal",
            headerText: "Subscription has been canceled",
            closeOnEscape: false,
            closable: false
        });
    }
}
